// Mapping between service IDs (from servicesData.json) and FAQ categories (from ServiceFAQsData.js)
export const serviceFAQMapping = {
  "menu-engineering": "Menu Management",
  "digital-profiling": "Website Design",
  "branding-marketing": "Digital Marketing",
  "employee-management": "Staff Training",
  "infrastructure-management": "Infrastructure",
  "delivery-platforms": "POS Integration",
  "process-optimization": "Purchase Management",
  "crm": "CRM",
  "catering-events": "Offers & Promotions",
  "kitchen-operations": "Menu Management",
  "inventory-management": "Purchase Management",
  "financial-accounts": "Purchase Management",
};

// Function to get FAQ service name from service ID
export const getFAQServiceName = (serviceId) => {
  return serviceFAQMapping[serviceId] || null;
};
